const state = {
  modalidad_data: [],
};

export default state;
